import { withSpacing } from '../../util/spacing.js';
import { Direction } from '../../contexts/session/Locale.js';
import styled from 'styled-components';

var IconStyled = /*#__PURE__*/styled(withSpacing('svg')).withConfig({
  displayName: "Iconstyled__IconStyled",
  componentId: "sc-1fugtov-0"
})(function (props) {
  var $fill = props.$fill,
    $size = props.$size,
    $direction = props.$direction;
  return {
    fill: $fill,
    minWidth: $size,
    minHeight: $size,
    maxWidth: $size,
    maxHeight: $size,
    transform: $direction === Direction.RTL ? 'scaleX(-1)' : undefined
  };
});

export { IconStyled };
//# sourceMappingURL=Icon.styled.js.map
